const getUsage = ({ workflowCount, workflowStepCount }) => {
  if (workflowCount === 0) {
    return { label: 'Never used', title: 'Never used' };
  }

  return {
    label: `${workflowCount} workflow${workflowCount > 1 ? 's' : ''}`,
    title: `Used in ${workflowCount} workflow${workflowCount > 1 ? 's' : ''} across ${workflowStepCount} step${workflowStepCount > 1 ? 's' : ''}`
  };
};

export default getUsage;
